export default {"src":"/_next/static/media/exclusive-offer.72403838.svg","height":189,"width":198,"blurWidth":0,"blurHeight":0};